<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar [class.shorten]="step === 2">
    <ion-buttons slot="start" *ngIf="step === 2">
      <ion-button
        class="go-back"
        expand="full"
        [attr.data-cy]="'edit-recipe-details-modal-back-button'"
        (click)="goBackAndSave()"
      >
        <ion-icon
          src="../../../../../assets/icon/chevron-left.svg"
          slot="start"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label class="title-bold">
      {{
        (step === 1
          ? 'i18n.menuProfitPro.editDetails.title'
          : 'i18n.menuProfitPro.editDetails.group'
        ) | translate
      }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  data-cy="edit-recipe-details-modal-content"
  class="simple-action-modal_content"
  tabletTouchMove
  scroll-y="false"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <ion-grid>
    <ion-row *ngIf="step === 1">
      <ion-col>
        <div>
          <img
            *ngIf="imageSrc"
            class="recipe-image"
            [attr.data-cy]="'recipe-card-image'"
            [src]="imageSrc"
          />
          <div
            *ngIf="!imageSrc"
            data-cy="recipe-no-image-icon"
            class="recipe-image"
          >
            <ion-icon name="restaurant"></ion-icon>
          </div>
          <div class="edit-image">
            <ion-icon
              src="../../../../assets/icon/pencil-green.svg"
              (click)="openProfileImageModal()"
            ></ion-icon>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="step === 1">
      <ion-col>
        <ion-item class="remove-border">
          <ion-label class="label" position="stacked">{{
            'i18n.menuProfitPro.editDetails.name' | translate
          }}</ion-label>
          <ion-input
            [(ngModel)]="formData.name"
            [placeholder]="
              'i18n.menuProfitPro.editDetails.namePlaceholder' | translate
            "
            (ngModelChange)="onNameChange($event)"
            [class.error]="nameIsEmpty || nameContainsEmojis || nameIsDuplicate"
            [maxlength]="100"
          ></ion-input>
        </ion-item>
        <div
          class="error-messages"
          *ngIf="nameIsEmpty || nameContainsEmojis || nameIsDuplicate"
        >
          <p
            *ngIf="nameContainsEmojis || nameIsEmpty"
            class="invalid-character"
          >
            {{
              'i18n.menuProfitPro.createModal.invalidCharacterError' | translate
            }}
          </p>
          <p *ngIf="nameIsDuplicate" class="invalid-character">
            {{
              'i18n.menuProfitPro.createModal.nameDuplicateError' | translate
            }}
          </p>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="step === 1">
      <ion-col>
        <ion-item class="remove-border">
          <ion-label class="label" position="stacked">{{
            'i18n.menuProfitPro.editDetails.description' | translate
          }}</ion-label>
          <ion-input
            [(ngModel)]="formData.description"
            [placeholder]="
              'i18n.menuProfitPro.editDetails.descriptionPlaceholder'
                | translate
            "
            (ngModelChange)="onDescriptionChange($event)"
            [maxlength]="100"
            [class.error]="!!descriptionContainsEmojis"
          ></ion-input>
        </ion-item>
        <div class="error-messages" *ngIf="descriptionContainsEmojis">
          <p *ngIf="descriptionContainsEmojis" class="invalid-character">
            {{
              'i18n.menuProfitPro.createModal.invalidCharacterError' | translate
            }}
          </p>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="step === 1">
      <ion-col>
        <ion-item
          [attr.data-cy]="'highlighted-selectable-item'"
          class="highlighted-selectable-item"
          detail="true"
          (click)="onMoveToGroup()"
        >
          <ion-label>
            <p data-cy="label" class="label bold">
              {{ 'i18n.menuProfitPro.editDetails.group' | translate }}
            </p>
            <p data-cy="value" class="value">
              {{
                (!formData.group
                  ? 'i18n.menuProfitPro.editDetails.group'
                  : formData.group
                ) | translate
              }}
            </p>
          </ion-label>
        </ion-item>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="step === 2">
      <ion-col>
        <ion-radio-group
          name="radio-selection"
          value="{{ formData.group }}"
          (ionChange)="onGroupSelection($event)"
        >
          <ion-item-divider *ngIf="groupNames?.length > 0" class="clamp-height">
          </ion-item-divider>
          <ion-item *ngFor="let group of groupNames" class="single-select-item">
            <ion-radio
              mode="md"
              labelPlacement="start"
              value="{{ group }}"
              [attr.data-cy]="group + '-radio-button'"
              class="single-select-radio"
            >
              <div class="radio-label item-subtitle-regular">
                {{ group }}
              </div>
            </ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="step === 2">
      <ion-col>
        <ion-input
          class="push-down"
          [(ngModel)]="tempGroupName"
          [placeholder]="'i18n.menuProfitPro.editDetails.addGroup' | translate"
          (ngModelChange)="onGroupChange($event)"
          [class.error]="groupContainsEmojis"
        >
          <ion-icon
            slot="end"
            name="add-outline"
            (click)="onAddGroup()"
          ></ion-icon>
        </ion-input>
        <div
          class="error-messages"
          *ngIf="groupContainsEmojis && tempGroupName !== ''"
        >
          <p *ngIf="groupContainsEmojis" class="invalid-character">
            {{
              'i18n.menuProfitPro.createModal.invalidCharacterError' | translate
            }}
          </p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="cancel-modal-btn"
        data-cy="cancel-edit-details-modal-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        "
        (click)="dismiss()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        id="save-modal-btn"
        data-cy="save-edit-details-modal-button"
        [ngClass]="
          platform !== platformRef.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        [disabled]="
          nameIsEmpty ||
          descriptionContainsEmojis ||
          nameContainsEmojis ||
          nameIsDuplicate ||
          groupContainsEmojis
        "
        (click)="submit()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
